import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Row, Col, Button, Badge } from "react-bootstrap";
import { fetchJobLogDetails } from "pages/ACD/actions/JobLogsActions";
import { DataTable } from "CommonComponent";
import moment from "moment";

const View = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const acdReportState = useSelector(state => state.acdReportState);
  const session = useSelector(state => state.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  useEffect(() => {
    if (id && object_viewed_id) {
      dispatch(fetchJobLogDetails(id, { object_viewed_id }));
    }
  }, [dispatch, id, object_viewed_id]);

  const { jobLogDetails } = acdReportState;
  const { data, loading } = jobLogDetails || {};
  const job = data?.job || {};
  const details = data?.details || [];

  const columns = [
    { id: "page_number", header: "Page Number", accessor: row => row.page_number, sortable: true },
    { id: "message", header: "Message", accessor: row => row.message, sortable: true },
    { 
        id: "status", 
        header: "Status", 
        accessor: row => (
            <Badge bg={row.status === 'Completed' ? 'success' : row.status === 'Failed' ? 'danger' : 'warning'}>
                {row.status}
            </Badge>
        ), 
        sortable: true 
    },
    { id: "created_at", header: "Created At", accessor: row => moment(row.created_at).format('YYYY-MM-DD HH:mm:ss'), sortable: true },
  ];

  if (loading) return <div>Loading...</div>;

  return (
    <div className="wrapper-div p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="font-24 font-weight-bold m-0">Job Log Details</h1>
        <Button variant="secondary" onClick={() => navigate(-1)}>Back</Button>
      </div>

      <Card className="mb-4">
        <Card.Header as="h5">Job Summary</Card.Header>
        <Card.Body>
             <Row className="mb-2">
                <Col md={3}><strong>Job Name:</strong></Col>
                <Col>{job.job_name}</Col>
             </Row>
              <Row className="mb-2">
                <Col md={3}><strong>Integration:</strong></Col>
                <Col>{job.integration_name} ({job.integration_type})</Col>
             </Row>
              <Row className="mb-2">
                <Col md={3}><strong>Run Date:</strong></Col>
                <Col>{job.run_datetime ? moment(job.run_datetime).format('YYYY-MM-DD HH:mm:ss') : '-'}</Col>
             </Row>
              <Row className="mb-2">
                <Col md={3}><strong>Status:</strong></Col>
                 <Col>
                    <Badge bg={job.status === 'Completed' ? 'success' : job.status === 'Failed' ? 'danger' : 'warning'}>
                        {job.status}
                    </Badge>
                 </Col>
             </Row>
             <Row className="mb-2">
                <Col md={3}><strong>Requests (Success/Error):</strong></Col>
                <Col>{job.success_requests} / {job.error_requests}</Col>
             </Row>
             {job.metadata && (
                 <Row>
                     <Col md={3}><strong>Metadata:</strong></Col>
                     <Col><pre>{JSON.stringify(job.metadata, null, 2)}</pre></Col>
                 </Row>
             )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header as="h5">Log Details</Card.Header>
        <Card.Body className="p-0">
             <DataTable
                columns={columns}
                data={details}
                serverSide={false}
                showSearch={true}
                className='table-container'
                defaultSortField="created_at"
                defaultSortAsc={true} 
            />
        </Card.Body>
      </Card>
      
    </div>
  );
};

export default View;
